'use strict';

var operators = {
    '<': function (value) {
        return function (other) {
            return other < value;
        }
    },
    '<=': function (value) {
        return function (other) {
            return other <= value;
        }
    },
    '=': function (value) {
        return function (other) {
            return other === value;
        }
    },
    '>=': function (value) {
        return function (other) {
            return other >= value;
        }
    },
    '>': function (value) {
        return function (other) {
            return other > value;
        }
    }
};

operators['..'] = operators['<='];

module.exports = operators;



/*****************
 ** WEBPACK FOOTER
 ** ./src/operators.js
 ** module id = 1
 ** module chunks = 0
 **/